module.exports = __webpack_public_path__ + "static/img/Videoamp-Selected.e189d41.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/destinations/Videoamp-Selected.png
// module id = 612
// module chunks = 0